const getCookieByName = (cookie, name) => {
  const match = cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))

  if (match) {
    return match[2]
  }
}

export default getCookieByName
